// @core/api/endpoints/subscription/delete_add_on.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/subscription';

/**
 * Delete addon
 * Archives an addon. Existing subscribers retain access until their subscription ends.
 */
export async function DeleteAddOn(
  addon_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/addons/:addon_id`;
  requestPath = requestPath.replace(':addon_id', encodeURIComponent(addon_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
